<template>
  <div
    ref="contextReference"
    class="context-message relative"
    :class="{ cut: !readMore}" >
    <div class="context-title flex flex-align-center SB-border bottom">
      <img
        v-if="contextMessage.sender_icon && contextMessage.sender_icon.dark"
        class="context-icon mr-1"
        :src="contextMessage.sender_icon.dark" >
      <span class="context-name">{{ contextMessage.sender }}</span>
    </div>
    <a
      v-if="mainUrl"
      class="main-url SB-border bottom flex"
      :href="mainUrl.value.url"
      target="_blank" >
      <div
        v-if="mainUrl.value.image"
        class="meta-image no-shrink"
        :style="{ backgroundImage: `url(${mainUrl.value.image})` }" />
      <div
        v-else
        class="meta-image placeholder-wrapper no-shrink" >
        <div class="placeholder-image" />
      </div>
      <div
        ref="mainUrlMetaText"
        class="meta-text ml-2 greedy flex column">
        <h3
          ref="mainUrlMetaTitle"
          class="meta-title multiline-ellipsis" >{{ mainUrl.value.title ? mainUrl.value.title : contextMessage.sender }}</h3>
        <p
          ref="mainUrlMetaDescription"
          class="meta-description multiline-ellipsis"
          :class="{ small: !mainUrl.value.description }" >{{ mainUrl.value.description ? mainUrl.value.description : mainUrl.value.url }}</p>
      </div>
    </a>
    <div
      v-for="(section, index) in contextMessage.context_preview.filter(cp => cp.field_type !== 'main_url')"
      :key="index"
      class="section">
      <h3>{{ section.name }}</h3>
      <div class="content">
        <p v-if="section.field_type === 'text'">{{ section.value }}</p>
        <a
          v-if="section.field_type === 'url'"
          class="no-decoration flex flex-align-center"
          :href="section.value.url"
          target="_blank" >
          <SBIcon
            class="mr-1"
            :icon="SBIconList.HYPERLINK"
            :color="SBColors.blackLight"
            :size="12" />
          <p
            class="ellipsis" >{{ section.value.url }}</p>
        </a>
      </div>
      <!-- META DATA VIEW -->
      <!-- <a
        v-else-if="section.field_type === 'url'"
        class="meta-data flex"
        :href="section.value.url"
        target="_blank" >
        <div
          v-if="section.value.image"
          class="meta-image no-shrink"
          :style="{ backgroundImage: `url(${section.value.image})` }" />
        <div class="meta-text ml-2 greedy flex column">
          <h3
            class="meta-title multiline-ellipsis me-1"
            :class="{ lighter: !section.value.title }" >{{ section.value.title ? section.value.title : 'No title' }}</h3>
          <p
            class="meta-description multiline-ellipsis me-2"
            :class="{ lighter: !section.value.description }" >{{ section.value.description ? section.value.description : 'No description' }}</p>
        </div>
      </a> -->
    </div>
    <div
      v-if="bigOne"
      class="read-more-wrapper" >
      <div
        class="read-more flex p-2 flex-align-center"
        @click="expand()" >
        <SBIcon
          class="down-arrow"
          :icon="SBIconList.ARROW_THIN_TIP_RIGHT"
          :color="SBColors.blackLight"
          :size="12"
          :hover-size="30"
          :rotate="readMore ? -90 : 90" />
        <span class="">View {{ readMore ? 'less' : 'more' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import SBIcon from '../../../common/Icon';
import SBIconList from '../../../../helpers/lists/sb-icon-list';
import SBColors from '../../../../helpers/lists/colors';

export default {
  name: 'ContextPreview',
  components: {
    SBIcon,
  },
  props: {
    contextMessage: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      maxInitialHeight: 343,
      readMore: false,
      bigOne: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    mainUrl() {
      return this.contextMessage.context_preview.find(s => s.field_type === 'main_url');
    },
  },
  mounted() {
    this.bigOne = this.$refs.contextReference ? this.$refs.contextReference.scrollHeight > this.maxInitialHeight : false;

    // Setting up main url title and description to fit max image height
    if (this.mainUrl) {
      const mainUrlMaxHeight = 84;
      const titleRowHeight = 16.5;
      const descriptionRowHeight = 16;
      const mainUrlMetaTextHeight = this.$refs.mainUrlMetaText.offsetHeight;
      const mainUrlMetaTitleHeight = this.$refs.mainUrlMetaTitle.offsetHeight;
      const mainUrlMetaDescriptionHeight = this.$refs.mainUrlMetaDescription.offsetHeight;

      const availableDescriptionRows = Math.floor((mainUrlMaxHeight - mainUrlMetaTitleHeight) / descriptionRowHeight);
      this.$refs.mainUrlMetaDescription.classList.add(`me-${availableDescriptionRows}`);
    }
  },
  methods: {
    expand() {
      this.readMore = !this.readMore;
      if (this.readMore) {
        this.$refs.contextReference.style.maxHeight = `${this.$refs.contextReference.scrollHeight + 50}px`;
        this.$refs.contextReference.style.height = `${this.$refs.contextReference.scrollHeight + 50}px`;
      } else {
        this.$refs.contextReference.style.maxHeight = `${this.maxInitialHeight}px`;
        this.$refs.contextReference.style.height = `${this.maxInitialHeight}px`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.context-message {
  background: $white;
  color: black;
  width: 329px;
  transition: all .3s ease;

  &.cut {
    max-height: 343px;

    .read-more-wrapper {
      height: 136px;
    }
  }

  .context-title {
    padding: 15px !important;
  }

  .context-icon {
    height: 14px;
    width: 14px;
    flex-shrink: 0;
  }

  .context-name {
    font-size: 14px;
    font-weight: 500;
    color: #2a383f;
  }

  a.main-url {
    min-width: 1px;
    justify-content: center;
    padding: 15px;
    cursor: pointer;

    *, &:hover, &:hover * {
      text-decoration: none;
    }

    &:not(:last-child) {
      margin-bottom: 15px;
    }

    .meta-image {
      width: 86px;
      height: 86px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      border-radius: 8px;
      border: solid 1px #e0e3e5;

      &.placeholder-wrapper {
        background-color: #e6ebed;

        .placeholder-image {
          mask-image: url(~@/assets/img/SB-Icons/image-placeholder-2.svg);
          mask-size: 23px auto;
          mask-repeat: no-repeat;
          mask-position: center;
          background-color: #7F8B90;
          width: 100%;
          height: 100%;
        }
      }
    }

    .meta-text {
      min-width: 1px;
      justify-content: center;
    }

    .meta-title {
      margin-top: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.2;
      color: #2a383f;

      &.lighter {
        color: $blackUltralight;
      }
    }

    .meta-description {
      font-size: 12px;
      font-weight: 400;
      line-height: 1.4;
      color: $blackUltralight;

      &.lighter {
        color: $greyPrimary;
      }

      &.small {
        -webkit-line-clamp: 1 !important;
      }
    }
  }

  .section {
    padding: 0 15px 0 15px !important;
    margin-top: 10px;

    &:nth-child(2) {
      margin-top: 15px !important;
    }

    &:last-child {
      padding-bottom: 15px !important;
    }

    h3 {
      font-size: 12px;
      font-weight: 500;
      line-height: 1.4;
      color: $blackUltralight;
    }

    .content {
      margin-top: 5px;
    }

    p {
      font-size: 14px;
      line-height: 1.2;
      color: $blackPrimary;
    }
  }

  .read-more-wrapper {
    position: absolute;
    height: 57px;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4) 35%, $white 78%, $white);
    transition: all .3s ease;

    .read-more {
      position: absolute;
      bottom: 0;
      cursor: pointer;
      padding-right: 20px !important;
      padding-bottom: 7px !important;
      padding-left: 5px !important;

      * {
        font-size: 14px;
        font-weight: 500;
        color: #54626c;
      }

      ::v-deep .down-arrow {
        margin-right: -8px;
        .icon {
          transition: transform 0.3s ease;
        }
      }

      &:hover {
        * {
          color: $blackPrimary;
        }

        ::v-deep .down-arrow {
          .icon.mask {
            background-color: $blackPrimary !important;
          }
        }
      }
    }
  }
}

::v-deep .no-decoration:hover {
  .icon.mask {
    background-color: $blackPrimary !important;
  }
}
</style>


<style lang="scss">
.multiline-ellipsis {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  background:#fff;
  overflow-wrap: anywhere;

  @for $i from 1 to 10 {
    &.me-#{$i}:not(.small) {
      -webkit-line-clamp: #{$i} !important;
    }
  }

  &.me-0 {
    display: none !important;
  }
}
</style>

<!-- If we ever decide to go back to skeleton wiew then everything is below this line. Some fine tuning on data structure may be needed but the pieces are here. -->

<!-- META DATA VIEW -->
<!-- <div
  v-else-if="metaData[section.value] && section.field_type === 'url'"
  class="meta-data flex" >
  <div
    v-if="metaData[section.value].image"
    class="meta-image no-shrink"
    :style="{ backgroundImage: `url(${metaData[section.value].image})` }" />
  <div class="meta-text ml-2 flex column">
    <h3 class="meta-title multiline-ellipsis me-1" >{{ metaData[section.value].title }}</h3>
    <p class="meta-description multiline-ellipsis me-2" >{{ metaData[section.value].description }}</p>
  </div>
</div> -->
<!-- LINK SKELETON -->
<!-- <div
  v-else-if="!metaData[section.value] && section.field_type === 'url'"
  class="skeleton flex">
  <div class="image-skelet no-shrink" />
  <div class="ml-2 flex column w-100 space-between">
    <div class="line-skelet" />
    <div class="line-skelet" />
  </div>
</div> -->

<!--
JS - watcher loads links and replaces the skeleton when loaded

watch: {
  contextMessage: {
    handler() {
      const links = this.contextMessage.context_preview.filter(cp => cp.field_type === 'url').map(cp => cp.value);
      if (links.length) {
        console.log('LOAD');
        console.log(links);
        links.forEach((link) => {
          console.log(link);
          api('GET', `/url-meta-data?url=${link}`, null, null, 'w')
            .then((response) => {
              console.log(response);
              if (response.status === 200) {
                // this.linkLoaded = true;
                this.metaData[link] = response.data;
                this.metaData = { ...this.metaData };
              }
            });
        });
      }
    },
    deep: true,
    immediate: true,
  },
},
-->

<!--
CSS

$animation-duration: 1.2s;
$avatar-offset: 60 + 8;

a.meta-data {
  min-width: 1px;
  justify-content: center;
  margin-top: 5px;
  cursor: pointer;

  *, &:hover, &:hover * {
    text-decoration: none;
  }

  .meta-image {
    width: 60px;
    height: 60px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 8px;
    border: solid 1px #e0e3e5;
  }

  .meta-text {
    min-width: 1px;
    justify-content: center;
  }

  .meta-title {
    margin-top: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    color: #2a383f;

    &.lighter {
      color: $blackUltralight;
    }
  }

  .meta-description {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    color: $blackUltralight;

    &.lighter {
      color: $greyPrimary;
    }
  }
}

.skeleton {
  margin-top: 5px;

  * {
    border-radius: 10px;
  }
  .image-skelet, .line-skelet {
    // background: $lightGray;
    background-image: linear-gradient(90deg, $greyBorderSecondary 0px, $lightGray 40px, $greyBorderSecondary 80px);
    background-size: 600px;
  }

  .image-skelet {
    width: 60px;
    height: 50px;
    animation: shine-image $animation-duration infinite linear
  }

  .line-skelet {
    width: 60%;
    height: 35%;
    animation: shine-line $animation-duration infinite linear
  }

  .line-skelet ~ .line-skelet {
    width: 100%;
  }
}

@keyframes shine-image {
  0% { background-position: -200px + $avatar-offset }
  100% { background-position: 300px + $avatar-offset }
}

@keyframes shine-line {
  0% { background-position: -200px }
  100% { background-position: 300px }
}
-->
